export default __webpack_public_path__ + "static/media/deleinternationalacademy.6280597e.png";